<script>
import { authComputed } from '@state/helpers'
import GoalIndicator from '@companies/components/goal-indicator.vue'

export default {
  name: 'OrganizationHeader',
  components: {
    GoalIndicator,
  },
  props: {
    organization: {
      type: Object,
      required: true,
    },
    isFollowed: {
      type: Boolean,
      default: false,
    },
    organizationId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...authComputed,
    backgroundImage() {
      return this.organization.background_url
    },
    logoImage() {
      return this.organization.logo
    },
    organizationGoals() {
      return this.organization.goals || []
    },
    goalFontSize() {
      let maxLength = 0
      let fontSize = 'text-4.5xl'
      for (var i = this.organizationGoals.length - 1; i >= 0; i--) {
        if (this.organizationGoals[i].achieved.toString().length > maxLength) {
          maxLength = this.organizationGoals[i].achieved.toString().length
        }
      }
      if (maxLength > 4) {
        fontSize = 'text-3xl'
      }
      return fontSize
    },
  },
  methods: {
    toggleFollow() {
      this.$emit('toggle-follow')
    },
  },
}
</script>

<template>
  <div class="bg-white">
    <div id="orgBackground">
      <img
        v-if="backgroundImage"
        :src="backgroundImage"
        alt="Organization background"
      />
      <div v-else class="bg-blue-lighter h-64"></div>
    </div>
    <div class="-mt-30 h-58 pl-15 pr-20 flex justify-between">
      <div
        class="w-58 h-58 bg-white rounded-full overflow-hidden shadow-input flex items-center justify-center"
      >
        <img v-if="logoImage" :src="logoImage" :alt="organization.name" />
        <div
          v-else
          class="w-full h-full bg-gray-lighter flex items-center justify-center text-4xl text-blue-darker"
        >
          {{ organization.name ? organization.name[0].toUpperCase() : 'O' }}
        </div>
      </div>
      <div class="mt-5 flex">
        <GoalIndicator
          v-for="goal in organizationGoals"
          :key="goal.type"
          :goal="goal"
          :font-size="goalFontSize"
        ></GoalIndicator>
      </div>
    </div>
  </div>
</template>

<style scoped>
#orgBackground {
  width: 100%;
  height: 16rem;
  overflow: hidden;
}

#orgBackground img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
